<template>
    <section id="RPsbsr-1587">
      <div class="cs-container">
        <picture class="cs-picture">
          <!--Mobile Image-->
          <source media="(max-width: 600px)" srcset="../assets/images/home-3.jpg">
          <!--Tablet and above Image-->
          <source media="(min-width: 601px)" srcset="../assets/images/home-3.jpg">
          <img loading="lazy" decoding="async" src="../assets/images/home-3.jpg" alt="models" width="586" height="690">
        </picture>
        <div class="cs-content">
          <span class="cs-topper">Our Approach</span>
          <h2 class="cs-title">Empowering Individuals with the Right Support</h2>
          <ul class="cs-card-group">
            <li v-for="(item, index) in processSteps" :key="index" class="cs-item">
              <div class="wrapper">
                <span class="cs-item-number">{{ item.number }}</span>
                <h3 class="cs-h3">{{ item.title }}</h3>
              </div>
              <p class="cs-item-text">{{ item.text }}</p>
            </li>
          </ul>
          <router-link to="/services" class="cs-button-solid">Explore Our Services</router-link>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: "ServicesSection",
    data() {
      return {
        processSteps: [
          { number: "01", title: "Person-Centered Care", text: "We take the time to understand each individual’s unique needs, preferences, and goals, ensuring tailored support that truly makes a difference." },
          { number: "02", title: "Holistic Well-Being", text: "Beyond assistance with daily tasks, we focus on overall well-being, encouraging social participation, community engagement, and emotional support." },
          { number: "03", title: "Collaboration & Respect", text: "We work closely with individuals, families, and caregivers to create a supportive environment where everyone feels heard and valued." },
          { number: "04", title: "Commitment to Excellence", text: "Our team is dedicated to delivering high-quality, reliable, and professional care that promotes independence and enhances lives." }
        ]
      };
    }
  };
  </script>
  
  <style scoped>

/*-- -------------------------- -->
<---        Side By Side        -->
<--- -------------------------- -*/

/* Mobile - 360px */
@media only screen and (min-width: 0rem) {
#RPsbs-1587,
#RPsbsr-1587 {
  padding: var(--sectionPadding);
  position: relative;
  z-index: 1;
}
#RPsbs-1587 .cs-container,
#RPsbsr-1587 .cs-container {
  width: 100%;
  /* changes to 1280px at tablet */
  max-width: 36.5rem;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* 48px - 64px */
  gap: clamp(2.5rem, 6vw, 4rem);
}
#RPsbs-1587 .cs-picture,
#RPsbsr-1587 .cs-picture {
  width: 100%;
  height: clamp(25rem, 80vw, 47rem);
  display: block;
  position: relative;
}
#RPsbs-1587 .cs-picture img,
#RPsbsr-1587 .cs-picture img {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
}
#RPsbs-1587 .cs-content,
#RPsbsr-1587 .cs-content {
  /* set text align to left if content needs to be left aligned */
  text-align: left;
  width: 100%;
  max-width: 39.375rem;
  display: flex;
  flex-direction: column;
  /* centers content horizontally, set to flex-start to left align */
  align-items: flex-start;
  justify-content: center;
}
#RPsbs-1587 .cs-title,
#RPsbsr-1587 .cs-title {
  /* 26 characters wide including spaces */
  max-width: 26ch;
  margin: 0;
}
#RPsbs-1587 .cs-card-group,
#RPsbsr-1587 .cs-card-group {
  width: 100%;
  /* 550px - 630px */
  max-width: clamp(34.375rem, 50vw, 39.375rem);
  padding: 0;
  /* 24px - 40px */
  margin: clamp(1.5rem, 4vw, 2.5rem) 0 clamp(1.75rem, 4vw, 2.5rem) 0;
  display: grid;
  align-items: center;
  gap: clamp(1rem, 4vw, 2.5rem);
}
#RPsbs-1587 .cs-item,
#RPsbsr-1587 .cs-item {
  list-style: none;
  /* prevents padding from affecting height and width */
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
}
#RPsbs-1587 .wrapper,
#RPsbsr-1587 .wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.625rem;
}
#RPsbs-1587 .cs-item-number,
#RPsbsr-1587 .cs-item-number {
  font-size: 1.25rem;
  line-height: 1.2em;
  font-weight: 700;
  margin: 0;
  color: var(--primary);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
}
#RPsbs-1587 .cs-h3,
#RPsbsr-1587 .cs-h3 {
  font-size: 1.25rem;
  line-height: 1.2em;
  font-weight: 700;
  margin: 0;
  color: var(--headerColor);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
}
#RPsbs-1587 .cs-item-text,
#RPsbsr-1587 .cs-item-text {
  font-size: 0.875rem;
  line-height: 1.5em;
  margin: 0;
  color: var(--bodyTextColor);
}
#RPsbs-1587 .cs-button-solid,
#RPsbsr-1587 .cs-button-solid {
  font-size: 1rem;
  line-height: 3.5em;
  text-decoration: none;
  font-weight: 700;
  overflow: hidden;
  width: auto;
  margin: 0;
  color: #fff;
  padding: 0 3rem;
  background-color: var(--primary);
  display: inline-block;
  position: relative;
  z-index: 1;
  transition: color 0.3s;
}
#RPsbs-1587 .cs-button-solid:before,
#RPsbsr-1587 .cs-button-solid:before {
  content: "";
  position: absolute;
  display: block;
  height: 100%;
  width: 0%;
  background: #1a1a1a;
  opacity: 1;
  top: 0;
  left: 0;
  z-index: -1;
  transition: width 0.3s;
}
#RPsbs-1587 .cs-button-solid:hover,
#RPsbsr-1587 .cs-button-solid:hover {
  color: var(--primary);
}
#RPsbs-1587 .cs-button-solid:hover:before,
#RPsbsr-1587 .cs-button-solid:hover:before {
  width: 100%;
}
}
/* Tablet - 768px */
@media only screen and (min-width: 48rem) {
#RPsbs-1587 .cs-container,
#RPsbsr-1587 .cs-container {
  max-width: 80rem;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
}
#RPsbs-1587 .cs-content,
#RPsbsr-1587 .cs-content {
  width: 50%;
  max-width: 39.375rem;
  /* prevents flexbox from squishing it */
  flex: none;
}
#RPsbs-1587 .cs-card-group,
#RPsbsr-1587 .cs-card-group {
  grid-template-columns: repeat(12, 1fr);
}
#RPsbs-1587 .cs-item,
#RPsbsr-1587 .cs-item {
  grid-column: span 6;
}
#RPsbs-1587 .cs-picture,
#RPsbsr-1587 .cs-picture {
  height: auto;
  min-height: 32.8125rem;
}
}
/* Small Desktop - 1024px */
@media only screen and (min-width: 64rem) {
#RPsbs-1587 .cs-content,
#RPsbsr-1587 .cs-content {
  padding: 5.25rem 0;
  align-self: center;
}
}

/*-- -------------------------- -->
<---   Side By Side Reverse     -->
<--- -------------------------- -*/

/* Mobile - 360px */
@media only screen and (min-width: 0rem) {
#RPsbsr-1587 {
  background-color: #f7f7f7;
}
}
/* Tablet - 768px */
@media only screen and (min-width: 48rem) {
#RPsbsr-1587 .cs-picture {
  order: 2;
}
}


  </style>
  